export default __webpack_public_path__ + "media/images/logos/m_logo_light-56effe59fc12999d9720747fb4452cde.png";